import React from 'react';
import {CircularProgress, ThemeProvider} from "@mui/material";
import useMUITheme from "../../hooks/useMUITheme";

// overlay=true (default): dims and covers the whole positioned ancestor while spinning, revealing
// children underneath once done - the original behavior, used to gate an already-rendered panel/modal.
// overlay=false: renders just the spinner centered in normal document flow, no absolute positioning/
// dimming - for a small standalone spinner row with nothing underneath to overlay.
export const Spin = ({size="large", wrapperClassName="", spinning=false, tip="", style={}, overlay=true, children}) => {
    let theme = useMUITheme();
    let sizeNum = 40;
    if (size === 'medium') {
        sizeNum = 30;
    } else if (size === 'small') {
        sizeNum = 20;
    }

    const spinner = (
        <ThemeProvider theme={theme}>
            <CircularProgress color={"primary"} enableTrackSlot size={sizeNum} thickness={3}/>
        </ThemeProvider>
    );

    if (!overlay) {
        return (
            <>
                {!!spinning &&
                    <div style={{display: "flex", alignItems: "center", justifyContent: "center", ...style}}>
                        {spinner}
                    </div>
                }
                {children}
            </>
        );
    }

    return (
        <>
            {!!spinning &&

                <div
                    style={{
                        position: "absolute", top: 0, left: 0,
                        background: "#FFFFFF99",  zIndex: 100000,
                        width: "100%", height: "100%",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        borderRadius: "inherit"
                    }}
                >
                    {spinner}
                </div>

            }

            {children}
        </>


    );
}
